/**
 * Retourne une fonction de comparaison alphabétique sur une clé d'objet.
 * @param {string} key
 * @returns {function}
 */
export const sortBy = key => (a, b) => (a[key] ?? '').localeCompare(b[key] ?? '')

/**
 * Comparaison alphabétique sur le label affiché d'un aéroport (icaoCode - name ou name).
 * @param {object} a
 * @param {object} b
 * @returns {number}
 */
export const sortByAirportLabel = (a, b) => {
  const labelA = a.icaoCode ? `${a.icaoCode} - ${a.name}` : a.name
  const labelB = b.icaoCode ? `${b.icaoCode} - ${b.name}` : b.name
  return labelA.localeCompare(labelB)
}

/**
 * Retourne une fonction de comparaison alphabétique sur le nom traduit d'un produit.
 * @param {string} locale
 * @returns {function}
 */
export const sortByProductName = locale => (a, b) => {
  const nameA = a.name?.[locale] ?? a.name?.en ?? ''
  const nameB = b.name?.[locale] ?? b.name?.en ?? ''
  return nameA.localeCompare(nameB)
}
